module.exports = require("@pb/kit-context-locale");